import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Info, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API } from "@/lib/api";
import { errMsg } from "./SocialPilotPanel";

const Stat = ({ title, rows }) => (
  <div className="border border-[#d5dbde] bg-white p-3">
    <div className="text-[10px] uppercase font-mono text-[#6b7280] mb-2">{title}</div>
    {rows.map((r) => <div key={r.k} className="flex justify-between text-xs py-0.5"><span className="truncate">{r.k}</span><b className="font-mono">{r.n}</b></div>)}
  </div>
);
const dur = (s) => (s >= 60 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${s}s`);

export const VisitorsPanel = () => {
  const [days, setDays] = useState(30);
  const [q, setQ] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => axios.get(`${API}/admin/visitors`, { params: { days, q: q || undefined } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e))), 300);
    return () => clearTimeout(t);
  }, [days, q]);
  return (
    <div data-testid="visitors-panel" className="space-y-4">
      <div><h2 className="font-display text-2xl">Visitatori del sito</h2><p className="text-sm text-[#6b7280]">Solo visitatori che hanno accettato i cookie analitici. IP anonimizzato (ultimo ottetto azzerato), dati cancellati dopo 90 giorni.</p></div>
      <p data-testid="visitors-phone-note" className="text-xs flex gap-2 bg-[#eff6ff] border border-[#bfdbfe] text-[#1e40af] p-3"><Info className="w-4 h-4 flex-shrink-0" /> Il numero di telefono NON è acquisibile automaticamente dal browser: lo ottieni solo se il visitatore lo inserisce volontariamente in un modulo (contatto, chat, checkout).</p>
      <div className="flex flex-wrap gap-2 items-center">
        {[1, 7, 30, 90].map((d) => <button key={d} type="button" data-testid={`visitors-days-${d}`} onClick={() => setDays(d)} className={`h-9 px-3 text-xs border ${days === d ? "bg-[#2B3036] text-white border-[#2B3036]" : "border-[#d5dbde] bg-white"}`}>{d === 1 ? "Oggi" : `${d} giorni`}</button>)}
        <div className="relative ml-auto"><Search className="w-4 h-4 absolute left-2.5 top-2.5 text-[#9ca3af]" /><Input data-testid="visitors-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="IP, città, pagina, referrer…" className="h-9 pl-8 w-64 bg-white" /></div>
      </div>
      {!data ? <Loader2 className="w-5 h-5 animate-spin" /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
            <div className="border border-[#d5dbde] bg-white p-3"><div className="text-[10px] uppercase font-mono text-[#6b7280]">Sessioni</div><div data-testid="visitors-total" className="font-display text-3xl">{data.stats.total}</div></div>
            <Stat title="Dispositivo" rows={data.stats.device} /><Stat title="Browser" rows={data.stats.browser} /><Stat title="Sistema" rows={data.stats.os} /><Stat title="Paese" rows={data.stats.country} />
          </div>
          <div className="border border-[#d5dbde] bg-white overflow-x-auto">
            <table className="w-full text-xs">
              <thead className="bg-[#f4f6f7] text-left text-[10px] uppercase font-mono text-[#6b7280]"><tr>{["Data/ora", "IP (anon.)", "Luogo", "Dispositivo", "Browser / OS", "Pagine", "Durata", "Referrer"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
              <tbody>{data.items.map((v) => (
                <tr key={v.sid} data-testid={`visitor-row-${v.sid}`} className="border-t border-[#e4e7e9] align-top">
                  <td className="px-3 py-2 font-mono whitespace-nowrap">{new Date(v.started_at).toLocaleString("it-CH")}</td>
                  <td className="px-3 py-2 font-mono">{v.ip_anon}</td>
                  <td className="px-3 py-2">{[v.city, v.country].filter(Boolean).join(", ") || "—"}</td>
                  <td className="px-3 py-2 capitalize">{v.device}</td>
                  <td className="px-3 py-2">{v.browser} · {v.os}</td>
                  <td className="px-3 py-2 max-w-[220px]"><span className="font-mono">{v.pages.length}</span> <span className="text-[#6b7280]">{v.pages.slice(0, 4).map((p) => p.path).join(" › ")}</span></td>
                  <td className="px-3 py-2 font-mono">{dur(v.duration_s)}</td>
                  <td className="px-3 py-2 truncate max-w-[180px]">{v.referrer || "diretto"}</td>
                </tr>
              ))}</tbody>
            </table>
            {!data.items.length && <p className="p-4 text-xs text-[#6b7280]">Nessuna visita nel periodo.</p>}
          </div>
        </>
      )}
    </div>
  );
};
